<rb-dialog (buttonClick)="onDialogButtonClick($event)"
           (closeClick)="onClose()"
           (maximizedChange)="onMaximizedChange($event)"
           [(maximized)]="dialogMaximized"
           [config]="dialogConfig">
  <div class="flex gap-x-[4rem]">
    <rb-view-section *ngIf="request.documents.length === 1" class="w-[calc(100%-47.9rem)]">
      <ng-container *ngrxLet="assignDocumentType$ | async as assignDocumentType">
        <div *ngrxLet="assignDocumentUrl$ | async as assignDocumentUrl"
             [style.max-height]="docViewerMaxHeight"
             class="overflow-hidden rounded-[0.5rem] h-[100vh] w-full">
          <rb-image-viewer *ngIf="assignDocumentType === 'image'"
                           alt="document"
                           class="block h-full w-full"
                           src="{{ assignDocumentUrl }}"></rb-image-viewer>
          <rb-pdf-viewer *ngIf="assignDocumentType === 'pdf'"
                         class="block h-full w-full"
                         src="{{ assignDocumentUrl }}"></rb-pdf-viewer>
          <div *ngIf="!assignDocumentType"
               class="flex flex-col justify-center items-center gap-y-[1rem] h-full">
            <mat-icon [class.icon-brand]="needsBrandColor(request.documents[0].extension)"
                      [svgIcon]="fileIcon(request.documents[0].extension)"
                      class="icon-40"></mat-icon>
            <span>{{ request.documents[0].name }}.{{ request.documents[0].extension }}</span>
          </div>
        </div>
      </ng-container>
    </rb-view-section>
    <rb-view-section *ngIf="request.documents.length !== 1"
                     [title]="'APP.DOCUMENT.ASSIGN_DOCUMENT.DIALOG.SELECTED_DOCUMENTS' | translate"
                     class="w-[calc(100%-47.9rem)]">
      <rb-selected-documents [documents]="request.documents"
                             class="block h-[66.4rem] overflow-scroll"></rb-selected-documents>
    </rb-view-section>
    <form [formGroup]="form"
          [style.height]="docViewerMaxHeight"
          class="w-[43.9rem] flex flex-col gap-y-[2rem]">
      <rb-document-name-bar (renamingChange)="onDocumentNameRenamingChange($event)"
                            *ngIf="request.documents.length === 1"
                            [clientId]="request.documents[0].client?.id"
                            [documentId]="request.documents[0].id"
                            [extension]="request.documents[0].extension"
                            [name]="request.documents[0].name"></rb-document-name-bar>
      <rb-select-client [clients]="assignDocumentClients$ | async"
                        [radioGroupHeight]="assignFormRadioGroupHeight"
                        formControlName="client"></rb-select-client>
    </form>
  </div>
</rb-dialog>
